export default new class collapse {
  constructor() {
    this.panelSelector = 'collapse__panel';
    this.linkSelector = 'collapse__link';
    this.contentSelector = 'collapse__content';
    this.contentActiveSelector = 'collapse__panel_active';

    this.init();
  }

  init() {
    $(document).on('click', `.${this.linkSelector}`, (e) => {
      e.preventDefault();
      const { currentTarget } = e;
      this.clickHandler(currentTarget);
    });
  }

  clickHandler(eventTarget) {
    const panel = $(eventTarget).parents(`.${this.panelSelector}`);
    panel.toggleClass(this.contentActiveSelector);
  }
}();
